module.exports = __webpack_public_path__ + "static/media/proposals.4b820905.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/panel/proposals.png
// module id = 797
// module chunks = 23